import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import { giveawayActions } from 'redux/actionCreators'
import classes from './AdminGiveaway.scss'
import { get, omit, omitBy, isNil, groupBy } from 'lodash'

// Components
import { Heading } from 'components'

// Helpers
import { hasChanged } from 'helpers/utilities'

@connect(state => ({
  giveaways: get(state, 'giveaway.giveaways') || [],
  pageCount: get(state, 'giveaway.pageCount') || 0
}), dispatch => ({
  attemptFindAllGiveaways: (payload) =>
    dispatch(giveawayActions.attemptFindAllGiveaways({ ...payload, limit: 1000 }))
}))
class AdminGiveaways extends Component {
  static contextTypes = {
    router: PropTypes.object.isRequired
  }

  componentWillMount () {
    this._findGiveaways(this.props)
  }

  componentWillReceiveProps (nextProps) {
    if (hasChanged(this.props, nextProps, ['location', 'query'])) {
      this._findGiveaways(nextProps)
    }
  }

  _findGiveaways = (props) => {
    const query = get(props, 'location.query') || {}
    this.props.attemptFindAllGiveaways(omitBy({
      offset: (parseInt(query.page || 1, 10) - 1) * 1000
    }, isNil))
  }

  _renderRow = ({ id, giveawayCode, productCodes, minimumSpend, minimumItem, status }, index) => (
    <tr key={id}>
      <td className='text-center'>{giveawayCode}</td>
      <td className='text-center'>{get(productCodes, 0) ? productCodes.join(', ') : 'ทุกการสั่งซื้อ'}</td>
      <td className='text-center'>{minimumSpend ? `${minimumSpend} บาท` : 'ไม่กำหนด'}</td>
      <td className='text-center'>{minimumItem ? `${minimumItem} ชิ้น` : 'ไม่กำหนด'}</td>
      <td className='text-center'>{status === 'active' ? 'ใช้งาน' : 'ไม่ใช้งาน'}</td>
    </tr>
  )

  render () {
    const { giveaways } = this.props
    const giveawaysByCode = groupBy(giveaways, ({ giveawayCode }) => giveawayCode)
    const resolvedGiveaways = Object.keys(giveawaysByCode).map(key => {
      const _giveaways = giveawaysByCode[key]
      const firstGiveaway = omit(get(_giveaways, 0), ['productCode'])
      return {
        ...firstGiveaway,
        productCodes: _giveaways.reduce((productCodes, { productCode }) => productCodes.concat([productCode]), [])
      }
    })
    return (
      <section className={classes.giveaways}>
        <Heading>สินค้าแถม</Heading>
        <table className='with-stripe desktop'>
          <thead>
            <tr>
              <th style={{ width: 60 }}>รหัสสินค้า</th>
              <th>แถมเมื่อซื้อสินค้า</th>
              <th style={{ width: 100 }}>แถมเมื่อซื้อเกินมูลค่า</th>
              <th style={{ width: 100 }}>แถมเมื่อซื้อครบ</th>
              <th style={{ width: 50 }}>สถานะ</th>
            </tr>
          </thead>
          <tbody>{resolvedGiveaways.map(this._renderRow)}</tbody>
          {!giveaways.length && <tr><td className='text-center' colSpan='8'>ยังไม่มีรายการสินค้าแถม</td></tr>}
        </table>
      </section>
    )
  }
}

export default AdminGiveaways



// WEBPACK FOOTER //
// ./src/containers/Admin/AdminGiveaway/AdminGiveaways.js